export default __webpack_public_path__ + "static/media/consul.ec0d0234.svg";